import { useAccessControl } from "./hooks/useAccessControl";
import AccessControlCard from "./components/AccessControlCard";
// import AuditHistory from "./components/AuditHistory";
import RestrictionModal from "./components/RestrictionModal";
import { SCOPE, ROLES_WITH_ACCESS_CONTROL } from "./constants";
import { getScopeCopy } from "./utils/accessControl.utils";

export default function AppAccessControl({ user }) {
  if (!user || !ROLES_WITH_ACCESS_CONTROL.includes(user.role)) {
    return null;
  }

  const scope = user.role === "superadmin" ? SCOPE.DISTRICT : SCOPE.SCHOOL;

  return <AppAccessControlInner scope={scope} />;
}

function AppAccessControlInner({ scope }) {
  const copy = getScopeCopy(scope);
  const {
    isRestricted,
    restriction,
    districtRestriction,
    isLockedByDistrict,
    // auditHistory,
    isLoading,
    isError,
    isCreating,
    isRevoking,
    modalOpen,
    modalMode,
    modalError,
    revokeError,
    // historyOpen,
    handleToggle,
    handleSave,
    handleRevoke,
    openEditModal,
    openCreateModal,
    closeModal,
    registerFormReset,
    // toggleHistory,
  } = useAccessControl(scope);

  return (
    <div className="flex flex-col gap-4 w-full">
      <AccessControlCard
        scope={scope}
        isRestricted={isRestricted}
        restriction={restriction}
        districtRestriction={districtRestriction}
        isLockedByDistrict={isLockedByDistrict}
        isLoading={isLoading}
        isError={isError}
        isRevoking={isRevoking}
        revokeError={revokeError}
        toggleLabel={copy.toggleLabel}
        toggleHint={copy.toggleHint}
        onToggle={handleToggle}
        onEdit={openEditModal}
        onRevoke={handleRevoke}
        onCreateSchoolRule={openCreateModal}
      />
      {/**
       * History section hidden per management request.
       * Enabling later only needs this block uncommented
       */}
      {/* {auditHistory.length > 0 && (
        <AuditHistory
          entries={auditHistory}
          open={historyOpen}
          onToggle={toggleHistory}
        />
      )} */}
      <RestrictionModal
        open={modalOpen}
        mode={modalMode}
        isCreating={isCreating}
        error={modalError}
        onSave={handleSave}
        onClose={closeModal}
        scope={scope}
        registerFormReset={registerFormReset}
      />
    </div>
  );
}

export { useAccessControl } from "./hooks/useAccessControl";
export { useDistrictAccess } from "./hooks/useDistrictAccess";
export { useSchoolAccess } from "./hooks/useSchoolAccess";
export { useAppAccess } from "./hooks/useAppAccess";
export { default as AccessControlCard } from "./components/AccessControlCard";
export { default as ActiveRestrictDetails } from "./components/ActiveRestrictionDetails";
export { default as AuditHistory } from "./components/AuditHistory";
export { default as RestrictionModal } from "./components/RestrictionModal";
export { default as ToggleSwitch } from "./components/ToggleSwitch";
